export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11988.4f2e0b92.jpg";